module.exports = __webpack_public_path__ + "./img/configure.4ccbc9a454183ea2a22c5266ca1fa6cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/configure.png
// module id = ./assets/images/configure.png
// module chunks = 0